import { EINNO_TENANTVERSION } from ".";
const standardTmpl = `
<div class="pt-inno-card__img">
    <% if (img) { %>
        <img src="{{img}}" />
    <% } %>
</div>
<p class="pt-inno-card__title">
    <span>{{title}}</span>
</p>
<div class="pt-inno-card__btn">
    <span class="pt-inno-card__btn-label">{{button}}</span>
    <svg width="24" height="24" fill="#fff" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path d="M13 17.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 1.414-1.414L11 17.586V4a1 1 0 0 1 2 0v13.586z" id="solid-arrow-tail-right"></path></defs><use transform="matrix(0 1 1 0 0 0)" xlink:href="#solid-arrow-tail-right" fill-rule="evenodd"></use></svg>
</div>
<div class="pt-inno-card__close">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.74189 2.80649C3.48036 2.60314 3.10221 2.62163 2.86189 2.86195C2.60154 3.1223 2.60154 3.54441 2.86189 3.80476L7.05715 8.00002L2.86189 12.1953L2.80643 12.2581C2.60308 12.5196 2.62157 12.8978 2.86189 13.1381C3.12224 13.3984 3.54435 13.3984 3.8047 13.1381L7.99996 8.94283L12.1952 13.1381L12.258 13.1936C12.5196 13.3969 12.8977 13.3784 13.138 13.1381C13.3984 12.8777 13.3984 12.4556 13.138 12.1953L8.94277 8.00002L13.138 3.80476L13.1935 3.74195C13.3968 3.48043 13.3784 3.10227 13.138 2.86195C12.8777 2.6016 12.4556 2.6016 12.1952 2.86195L7.99996 7.05721L3.8047 2.86195L3.74189 2.80649Z" fill="#807D7D"/>
    </svg>
</div>
`;
const professionalTmpl = `
<div class="pt-inno-card__info">
    <p class="pt-inno-card__title">
        <span>{{title}}</span>
    </p>
    <p class="pt-inno-card__desc">
        <span>{{desc}}</span>
    </p>
    <div class="pt-inno-card__btn">
        <span class="pt-inno-card__btn-label">{{button}}</span>
        <svg width="24" height="24" fill="#fff" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path d="M13 17.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 1.414-1.414L11 17.586V4a1 1 0 0 1 2 0v13.586z" id="solid-arrow-tail-right"></path></defs><use transform="matrix(0 1 1 0 0 0)" xlink:href="#solid-arrow-tail-right" fill-rule="evenodd"></use></svg>
    </div>
</div>
<div class="pt-inno-card__img">
    <% if (img) { %>
        <img src="{{img}}" />
    <% } %>
</div>
<div class="pt-inno-card__close">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.74189 2.80649C3.48036 2.60314 3.10221 2.62163 2.86189 2.86195C2.60154 3.1223 2.60154 3.54441 2.86189 3.80476L7.05715 8.00002L2.86189 12.1953L2.80643 12.2581C2.60308 12.5196 2.62157 12.8978 2.86189 13.1381C3.12224 13.3984 3.54435 13.3984 3.8047 13.1381L7.99996 8.94283L12.1952 13.1381L12.258 13.1936C12.5196 13.3969 12.8977 13.3784 13.138 13.1381C13.3984 12.8777 13.3984 12.4556 13.138 12.1953L8.94277 8.00002L13.138 3.80476L13.1935 3.74195C13.3968 3.48043 13.3784 3.10227 13.138 2.86195C12.8777 2.6016 12.4556 2.6016 12.1952 2.86195L7.99996 7.05721L3.8047 2.86195L3.74189 2.80649Z" fill="#807D7D"/>
    </svg>
</div>
`;
export function getTemplate(type) {
    return type === EINNO_TENANTVERSION.standard ? standardTmpl : professionalTmpl;
}
;
//# sourceMappingURL=templale.js.map